import type { InitOptions } from 'i18next';

// cimode short-circuits translation lookups: t(key) returns the key itself.
// Skips the AEM backend fetch, which doesn't exist in CI.
// Used identically by i18n-server and i18n-client when RUNTIME.isMockedTarget.
export const CIMODE_INIT_OPTIONS: InitOptions = {
  lng: 'cimode',
  fallbackLng: 'cimode',
  resources: { cimode: {} },
  preload: [],
  partialBundledLanguages: true,
  // Prevent useTranslation from suspending when a namespace isn't bundled;
  // renderToString throws on suspension.
  react: { useSuspense: false },
};

export const CIMODE_I18N_MODULE = {
  initialLanguage: 'cimode',
  initialI18nStore: { cimode: {} },
} as const;
